import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_authenticated/mfa-prompt")({
  component: MfaPromptPage,
});

function MfaPromptPage() {
  const { t } = useTranslation("mfa");

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="w-full max-w-md space-y-6 rounded-lg bg-white p-8 shadow-lg dark:bg-gray-800">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-primary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-on-surface">{t("prompt.title")}</h1>
          <p className="mt-2 text-sm text-muted">{t("prompt.description")}</p>
        </div>

        <div className="flex flex-col gap-3">
          <Link
            to="/settings/mfa"
            className="block w-full rounded-md bg-primary px-4 py-2.5 text-center text-sm font-medium text-on-primary hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            {t("prompt.setup")}
          </Link>
          <Link
            to="/"
            className="block w-full rounded-md border border-gray-300 px-4 py-2.5 text-center text-sm font-medium text-muted hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:border-gray-600 dark:hover:bg-gray-700"
          >
            {t("prompt.skip")}
          </Link>
        </div>
      </div>
    </div>
  );
}
